var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcWifi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 60,
    viewBox: "0 0 85 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.5631L7.7158 25.2789C26.8896 6.10513 57.9842 6.10513 77.158 25.2789L84.8738 17.5631C61.4564 -5.85436 23.456 -5.85436 0 17.5631ZM30.8632 48.4263L42.4369 60L54.0106 48.4263C52.4922 46.9038 50.6883 45.6959 48.7023 44.8717C46.7163 44.0475 44.5872 43.6233 42.4369 43.6233C40.2867 43.6233 38.1576 44.0475 36.1715 44.8717C34.1855 45.6959 32.3816 46.9038 30.8632 48.4263ZM15.4316 32.9947L23.1474 40.7105C28.2648 35.5974 35.2029 32.7252 42.4369 32.7252C49.671 32.7252 56.6091 35.5974 61.7264 40.7105L69.4422 32.9947C54.5507 18.1032 30.3617 18.1032 15.4316 32.9947Z",
    fill: "#2E3192"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWifi);
export default __webpack_public_path__ + "static/media/ic_wifi.dcc557afa928eb6836380250e837de38.svg";
export { ForwardRef as ReactComponent };